<div class="isg-moduleslist-wrapper">

  <kendo-listbox [toolbar]="false"
                 height="100%"
                 width="100%"
                 [data]="dataItems"
                 (actionClick)="onActionClick($event)"
                 (selectionChange)="onSelectionEvent($event)"
                 [style.height.px]="heightList">
    <ng-template kendoListBoxItemTemplate let-dataItem>
       <input *ngIf="showCheckbox"
          type="checkbox"
          [indeterminate]="false"
          [(ngModel)]="dataItem.checked"
          kendoCheckBox
        />
        <span>{{ dataItem.name }}</span>
      </ng-template>
  </kendo-listbox>

</div>
